import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CarCrashIcon(props: IconProps) {
    return <Icon {...props} iconKey={"car_crash"}/>
}
